import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-dimensions-inclusions"
}
const _hoisted_2 = {
  key: 0,
  class: "house-info-card"
}
const _hoisted_3 = { class: "house-info-card-row-modified" }
const _hoisted_4 = { class: "row-value" }
const _hoisted_5 = { class: "house-info-card-row-modified" }
const _hoisted_6 = { class: "row-value" }
const _hoisted_7 = { class: "house-info-card-row-modified" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = {
  key: 1,
  class: "house-info-card"
}
const _hoisted_10 = { class: "house-info-card-row-modified" }
const _hoisted_11 = { class: "row-label" }
const _hoisted_12 = {
  key: 2,
  class: "house-info-card"
}
const _hoisted_13 = { class: "house-info-card-row-modified" }
const _hoisted_14 = { class: "row-label" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.houseInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($props.isDimensionsOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "Floor Plan Area", -1)),
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-label" }, "Area:", -1)),
                _createElementVNode("div", _hoisted_4, _toDisplayString($setup.formatMeters($setup.props.houseInfo.area, false)) + " SQM", 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-label" }, "Width:", -1)),
                _createElementVNode("div", _hoisted_6, _toDisplayString($setup.formatMeters($setup.props.houseInfo.width, false)) + " M", 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "Length:", -1)),
                _createElementVNode("div", _hoisted_8, _toDisplayString($setup.formatMeters($setup.props.houseInfo.length, false)) + " M", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        ($props.isDimensionsOpen && $setup.props.houseInfo.features)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Features", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.houseInfo.features, (feature) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(feature), 1)
                ]))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        ($props.isInclusionsOpen && $setup.props.houseInfo.inclusions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "Inclusions", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.houseInfo.inclusions, ({ name, url }) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(name), 1),
                    _createElementVNode("a", {
                      class: "row-value highlighted",
                      href: url,
                      target: "_blank"
                    }, "Download", 8, _hoisted_15)
                  ])
                ]))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}